import type { AppRegion } from "@core-types/region.enum";
import I18nHelper, { type Language } from "./I18nHelper";

export interface IRegionUrlParams {
  language?: Language;
  region: AppRegion;
  uri?: string[];
}

export default class UrlHelper {
  static getI18nRegionsUrl({
    language,
    region,
    uri,
  }: IRegionUrlParams): string {
    const parts: string[] = [];

    if (language) {
      parts.push(language);
    }

    const category = uri && uri.length > 0 ? uri[0] : undefined;
    const leftUris = uri && uri.length > 1 ? uri.slice(1) : [];

    if (category) {
      if (category === "skin") {
        parts.push(category);
      } else {
        parts.push(category, region);
      }

      if (leftUris.length > 0) {
        parts.push(...leftUris);
      }
    }
    const rawUrl = `${parts.join("/")}`;

    if (!language) {
      return rawUrl;
    }

    const cleanUrl = I18nHelper.getLangHref(rawUrl, language);

    return cleanUrl;
  }
}
